/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Alert, Button, IconButton, Paper } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import DataEditor from "./DataEditor";
import { createAdvertisementDataSource } from "../../api/advertisement-data-list";
import Filters from "../../../../shared/ui/filters/index.jsx";
import { EDIT_ADVERTISMENT_DATA, EXPORT_ADVERTISMENT_DATA, GET_ALL_ADVERTISMENT_DATA } from "../../../../shared/api/endpoints.js";

const AdvertismentData = () => {
  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState({});
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshData, setRefresh] = useState(0);
  const { token } = useSelector((state) => state.user);
  const source = useMemo(() => createAdvertisementDataSource(token), [token, refreshData]);
  const { hasMore, loading, errors, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_ADVERTISMENT_DATA,
      filter,
      true,
      refreshData,
      sumbitSearch, 1, false, undefined, source.requestPage
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  return (
    <>
      <PageTitle
        title="تبلیغات  مقادیر"
        broadCrumb={[
          {
            title: "تبلیغات",
            path: "/advertisment",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        {errors && <Alert severity="error">دریافت کامل فهرست انجام نشد؛ برای تلاش مجدد جدول را به‌روز کنید.</Alert>}
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
   
                <Exports
                  requestExport={source.requestExport}
                  sumbitSearch={sumbitSearch}
                  filter={filter}
                  header={header}
                  data={allData}
                  selectedData={selected}
                  title="تبلیغات "
                  api={EXPORT_ADVERTISMENT_DATA}
                />
        

              <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن تبلیغات جدید
              </Button>
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_ADVERTISMENT_DATA}
          title="تبلیغات "
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"دسته بندی "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <DataEditor open={openEdit || openCreate} editing={openEdit} data={openEdit ? editingData : null}
        close={() => { setOpenEdit(false); setOpenCreate(false); setEditingData({}); }}
        onSaved={() => setRefresh((value) => value + 1)} />
      {/*       <BoothModal
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      /> */}
    </>
  );
};

export default AdvertismentData;
